import { Module } from 'vuex'

interface ReviewPageState {
  isFirstOpendPage: boolean
  entrySummaryExpandedList: { [entryId: string]: boolean }
  entrySelectedReviewIndexList: { [entryId: string]: number }
}

export const reviewPageStateModule = (): Module<ReviewPageState, any> => {
  return {
    namespaced: true,
    state: {
      isFirstOpendPage: true,
      entrySummaryExpandedList: {},
      entrySelectedReviewIndexList: {}
    },
    mutations: {
      setIsFirstOpendPage(state, { flag }: { flag: boolean }) {
        state.isFirstOpendPage = flag
      },
      setEntrySummaryExpandedList(state, { list }: { list: { [entryId: string]: boolean } }) {
        state.entrySummaryExpandedList = list
      },
      setEntrySelectedReviewIndexList(state, { list }: { list: { [entryId: string]: number } }) {
        state.entrySelectedReviewIndexList = list
      },
      setEntrySummaryExpandedFlag(state, { entryId, flag }: { entryId: string; flag: boolean }) {
        state.entrySummaryExpandedList[entryId] = flag
      },
      setEntrySelectedReviewIndex(
        state,
        { entryId, selectedReviewIndex }: { entryId: string; selectedReviewIndex: number }
      ) {
        state.entrySelectedReviewIndexList[entryId] = selectedReviewIndex
      }
    },
    actions: {},
    getters: {
      isFirstOpendPage: state => state.isFirstOpendPage,
      entrySummaryExpandedList: state => state.entrySummaryExpandedList,
      entrySelectedReviewIndexList: state => state.entrySelectedReviewIndexList
    }
  }
}
